class ActivePolygonSubject {
  observers = []

  activePolygon = null

  attach(observer) {
    this.observers.push(observer)
    observer(this.activePolygon)
  }

  detach(observerToRemove) {
    this.observers.filter((observer) => observerToRemove !== observer)
  }

  notify(activePolygon) {
    this.activePolygon = activePolygon
    this.observers.forEach((observer) => observer(activePolygon))
  }
}

const activePolygonSubject = new ActivePolygonSubject()

export default activePolygonSubject
